module.exports = __webpack_public_path__ + "static/about-6484c5c94bf4197426c27b8648836047.jpg";